<!--
 * @Author: your name
 * @Date: 2020-07-09 15:45:54
 * @LastEditTime: 2020-07-27 10:43:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\views\maintain\Repair dispatch.vue
-->
<template>
    <div class="main">
        <div class="clearfix">
            <van-nav-bar
                class="restclass"
                title="派工单查看"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <van-tabs active="维修信息" bind:change="onChange">
            <van-tab title="维修信息">
                <van-row style="margin:5px; border-bottom:1px solid #ddd;padding:5px ">
                    <van-col :span="6"><span>报修信息</span></van-col>
                    <van-col style="color:red" @click="getSourceNo(form.sourceId)">{{ form.sourceNo }}</van-col>
                </van-row>
                <!-- <van-field
                    v-model="form.enumMaintenanceNameDisplay"
                    label="维修类型"
                    :disabled="true"
                    :required="true"
                    placeholder="请选择"
                    :border="true"
                    :rules="[ { required: true, message: '必填' } ]" />
                <van-field
                    v-model="form.faultDescription"
                    label="故障描述"
                    :border="true"
                    placeholder="请输入" /> -->
                <van-field
                    v-model="form.maintainItemName"
                    label="维修项目"
                    :border="true"
                    placeholder="请输入" @click="getMaintain" />
                <van-popup
                    v-model="showMaintain"
                    :style="{ height: '30%' }"
                    position="bottom">
                    <van-picker
                        item-height="1.173rem"
                        show-toolbar
                        :columns="maintainList"
                        @cancel="showMaintain = false"
                        @confirm="confirmMaintain" />
                </van-popup>
                <van-field
                    v-model="form.teamName"
                    label="维修队"
                    :border="true"
                    placeholder="请输入" @click="getTeam" />
                <van-popup
                    v-model="showTeam"
                    :style="{ height: '30%' }"
                    position="bottom">
                    <van-picker
                        item-height="1.173rem"
                        show-toolbar
                        :columns="Teams"
                        @cancel="showTeam = false"
                        @confirm="confirmTeam" />
                </van-popup>
                <div v-for="(item,index) of list" :key="index">
                    <van-row>
                        <van-col :span="11">
                            <van-field
                                v-model="item.workerName"
                                label="维修工"
                                :border="true"
                                placeholder="请输入" @click="getWorkers(index)" />
                            <van-popup
                                v-model="showdrivers"
                                :style="{ height: '30%' }"
                                position="bottom">
                                <van-picker
                                    item-height="1.173rem"
                                    show-toolbar
                                    :columns="workers"
                                    @cancel="showdrivers = false"
                                    @confirm="confirmmaintainItem" />
                            </van-popup>
                        </van-col>
                        <van-col :span="11">
                            <van-field
                                v-model="item.percent"
                                label="占比"
                                :border="true"
                                placeholder="请输入" />
                        </van-col>
                        <van-col :span="1" class="icon-style">
                            <van-icon name="plus" @click="addWorkOrder" />
                        </van-col>
                        <van-col :span="1" @click="deltWorkOrder(index)">
                            <div style="font-size:20px;margin-top:5px;">{{ item.deltBtn }}</div>
                        </van-col>
                    </van-row>
                </div>
            </van-tab>
            <van-tab title="基本信息">
                11111
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { getWorkOrder, displayteam } from '@/api/maintain'
import { getMaintenitemlistForDropdw, GetworkerByMtId } from '@/api/basics'
export default {
    name: 'RepairDispatch',
    data() {
        return {
            form: {
                enumMaintenanceNameDisplay: '现场维修',
                faultDescription: '',
                maintainItemId: '',
                maintainItemName: '',
                teamName: '',
                teamId: ''
            },
            showMaintain: false, // 维修项目
            showTeam: false, // 维修队
            showdrivers: false, // 维修工
            maintainList: [],
            Teams: [], // 维修队下拉
            // 维修工循环（维修工和占比）
            list: [
                { workerName: '', percent: '', deltBtn: '' }
            ],
            // 维修工下拉
            workers: [],
            index: ''
        }
    },
    mounted() {
        this.getDetails()
    },
    methods: {
        getBack() {
            this.$router.push({ path: '/' })
        },
        onChange(event) {

        },
        // 获取详情
        async getDetails() {
            const res = await getWorkOrder(this.$route.query.id)
            if (res.isSuccess) {
                console.log(res.data)
                this.form = res.data
                this.form.enumMaintenanceNameDisplay = '现场维修'
            }
        },
        getSourceNo(val) {
            alert('跳转原单据')
            // this.$router.push({
            //     path: '/',
            //     query: { id: val }
            // })
        },
        async getMaintain() {
            const res = await getMaintenitemlistForDropdw({})
            console.log(res.data)
            res.data.pagerData && res.data.pagerData.forEach(item => {
                item.text = item.name
            })
            this.maintainList = res.data.pagerData
            this.showMaintain = true
        },
        confirmMaintain(event) {
            const { text, id } = event
            this.form.maintainItemId = id
            this.form.maintainItemName = text
            this.showMaintain = false
        },
        // 获取维修队
        async getTeam() {
            const res = await displayteam(this.form.maintainItemId)
            if (res.isSuccess) {
                res.data.pagerData && res.data.pagerData.forEach(item => {
                    item.text = item.teamName
                })
                this.Teams = res.data.pagerData
            }
            this.showTeam = true
        },
        // 维修队
        confirmTeam(event) {
            const { text, teamId } = event
            this.form.teamName = text
            this.form.teamId = teamId
            this.list.forEach(element => {
                element.workerId = null
                element.workerName = null
                element.percent = null
            })
            this.showTeam = false
            console.log(this.form.teamId)
        },
        // 获取维修工
        async getWorkers(val) {
            console.log(val)
            this.index = val
            const res = await GetworkerByMtId({ MaintenanceTeamID: this.form.teamId })
            if (res.isSuccess) {
                res.data && res.data.forEach(item => {
                    item.text = item.workerName
                })
            }
            this.workers = res.data
            this.showdrivers = true
        },
        // 点击维修工加号
        addWorkOrder() {
            this.list.push({ workerName: '', percent: '', deltBtn: '-' })
        },
        // 点击减号删除
        deltWorkOrder(index) {
            this.list.splice(index, 1)
        },
        // 弹窗的确认
        confirmmaintainItem(event) {
            const { text, id } = event
            console.log(text, id)
            console.log(this.list)
            this.list[this.index].workerName = text
            this.list[this.index].workerId = id
            this.showdrivers = false
        }
    }
}
</script>

<style lang='scss'  scoped>
.main {
    width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
}
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.info-span {
    padding:0px 8px;
    color:#000;
}
.info-span-red {
    padding:0px 8px;
    color:#f00;
}
.noList{
    text-align: center;
    margin-top: 50%;
    font-size: 26px;
    color: #ccc;
}
.listMore{
    text-align: center;
    font-size: 26px;
    color: rgb(204, 204, 204);
}
.right-top-box{
    width:100px;
    height:100px;
    background-color: #555;
    color: #fff;
    /* Rotate div */
    transform:rotate(45deg);
    ms-transform:rotate(45deg); /* Internet Explorer */
    moz-transform:rotate(45deg); /* Firefox */
    webkit-transform:rotate(45deg); /* Safari 和 Chrome */
    o-transform:rotate(45deg); /* Opera */

    position: absolute;
    right: -50px;
    top: -50px;
}
.icon-style .van-icon{ margin-top: 25px;}
</style>
